/* istanbul ignore file */
export { generateCorrelationID, getLogger, isPrettyLogger } from './logger';
